import { golfScene_create } from './golfScene_create-sidecar'
import { golfScene_update } from './golfScene_update-sidecar'

export const create = () => {
  golfScene_create.create()
}
export const update = (time: number, delta: number) => {
  golfScene_update.update(time, delta)
}
